import UserService from "rc-app/services/UserService";
import { getAgentById, getAgentProfile } from "./agentActionsApi";
import { getRegionDetailsById } from "./regionActionsApi";
import { getCustomerProfile } from "./customerActionsApi";
import axios from "axios";
import { getClientAdminByEmailId, getClientManagerByEmailId } from "./systemBusinessAdminActionApi";


export const getAgencyLogo = async (email_id) => {
  try {
    console.log("customerLogin Logo 1");

    if (UserService.hasRole("super_admin")){
      return {
        logo: null,
        region: null,
        agencyName: null,
      };
    }
    if (UserService.hasRole("agent")) {
      console.log("customerLogin Logo Agent");
      const agentProfile = await getAgentProfile(email_id);
      const agencyId = agentProfile?.agent?.agency["id"];
      const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency/${agencyId}`;
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      // "Delhi-Punjab-UP-Marketing"
      // delhi-up-ap-marketing-Panjab
      // delhi-up-ap-marketing-Panjab-Marketing
      // "*-Marketing"
      // Telangana-Andhra Pradesh-marketing

      // i have to calculate the region_name from the region id that we get from the get_agency API
      const regionDetails = data.agency?.region_id ? await getRegionDetailsById(data.agency.region_id).catch(() => null) : null;
      console.log("agencyLogo3", data);

      return {
        logo: data.agency?.logo,
        region: regionDetails?.region,
        agencyName: data.agency?.name,
        slug: data.agency?.slug,
      };
    }
    console.log("customerLogin Logo 2");
    if (UserService.hasRole("customer")) {
      console.log("customerLogin Logo customer");
      const customerProfile = await getCustomerProfile(email_id);

      // Every customer carries an agency_id directly — resolve the agency from
      // it so the logo shows even for leads with no assigned agent. Fall back to
      // the assigned-agent hop only if agency_id is somehow absent.
      let agencyId = customerProfile?.customer?.agency_id;
      if (!agencyId) {
        const agentId = customerProfile?.customer?.agent_id?.[0];
        const agentProfile = agentId ? await getAgentById(agentId) : null;
        agencyId = agentProfile?.agent?.agency?.["id"];
      }
      const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency/${agencyId}`;
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("agencyLogo3Customer", data.agency?.logo);
      const regionDetails = data.agency?.region_id ? await getRegionDetailsById(data.agency.region_id).catch(() => null) : null;

      return {
        logo: data.agency?.logo,
        region: regionDetails?.region,
        agencyName: data.agency?.name,
        slug: data.agency?.slug,
      };
    }
    console.log("customerLogin Logo 3");
    if (UserService.hasRole("agency_business_admin")) {
      const clientManagerProfile = await getClientManagerByEmailId(email_id);
      console.log("agency_business_admin", clientManagerProfile?.agency_business_admin?.agency_id);
      const agencyId = clientManagerProfile?.agency_business_admin?.agency_id;
      const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency/${agencyId}`;
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("agency_business_admin", data.agency?.logo);
      const regionDetails = data.agency?.region_id ? await getRegionDetailsById(data.agency.region_id).catch(() => null) : null;

      return {
        logo: data.agency?.logo,
        region: regionDetails?.region,
        agencyName: data.agency?.name,
        slug: data.agency?.slug,
      };
    }

    if (UserService.hasRole("agency_system_admin")) {
      const clientAdminProfile = await getClientAdminByEmailId(email_id);
      console.log("agency_system_admin", clientAdminProfile?.agency_system_admin?.agency_id);
      const agencyId = clientAdminProfile?.agency_system_admin?.agency_id;
      const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency/${agencyId}`;
      const response = await fetch(API_URL, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          "ngrok-skip-browser-warning": "disabled",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("agency_system_admin 2", data.agency?.logo);
      const regionDetails = data.agency?.region_id ? await getRegionDetailsById(data.agency.region_id).catch(() => null) : null;

      return {
        logo: data.agency?.logo,
        region: regionDetails?.region,
        agencyName: data.agency?.name,
        slug: data.agency?.slug,
      };
    }
    


    // return { logo: data.agency?.logo, region: "Telangana-Andhra Pradesh-marketing" };
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};

/* ── Agencies, searched on the SERVER ─────────────────────────────────
 * This loaded the newest 200 and the page then filtered those in the
 * browser. On stage, where hundreds of throwaway agencies get created by
 * testing, an older real agency sits outside that window and can never be
 * found however carefully you type its name — which is how a super admin
 * ends up concluding it does not exist.
 *
 * `name` is a server-side filter on the list endpoint, so a search now
 * covers every agency rather than the most recent page of them.
 *
 * The character-class pattern is a workaround, not a flourish: the
 * backend builds `{"$regex": f"{name}*"}` with no case-insensitive
 * option, so "opensky" would not match "OpenSky Demo". Sending
 * [Oo][Pp][Ee][Nn]... matches either case without needing the backend
 * deployed first. Delete it the day that regex gains `$options: "i"`.
 */
const caseInsensitivePattern = (q) =>
  String(q || "")
    .trim()
    .replace(/[^\w\s-]/g, "")                 // the caller types a name, not a regex
    .split("")
    .map((ch) => (/[a-z]/i.test(ch) ? `[${ch.toLowerCase()}${ch.toUpperCase()}]` : ch))
    .join("");

export const getClientList = async (search = "") => {
  try {
    const q = caseInsensitivePattern(search);
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency?sort_by=created_at&sort_order=-1&page=0&limit=200${
      q ? `&name=${encodeURIComponent(q)}` : ""
    }`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const createClient = async (jsonData) => {
  try {
    console.log("create Client", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/re_agency`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    throw error;
  }
};



export const getClientIdByClientManger = async (emailId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_business_admin/email/${emailId}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getClientIdByClientAdmin = async (emailId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency_system_admin/email/${emailId}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching gender options:", error);
    return [];
  }
};

export const getAgencyById = async (agencyId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/re_agency/${agencyId}`;
    const response = await fetch(API_URL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data?.agency;
  } catch (error) {
    console.error("Error fetching agency:", error);
    return null;
  }
};



